import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppSetting } from '../../Models/app-setting';
import { Branch } from '../../Models/branch';
import { ServiceBase } from '../../shared/service-base/service-base';
import { TServiceResult } from '../../shared/Infra/TServiceResult';
import { ServiceResult } from '../../shared/Infra/ServiceResult';
import { LocalRepository } from '../data/repository/local-repository';


@Injectable()
export class AppSettingService extends ServiceBase<AppSetting>  {
  constructor(http: HttpClient,repo:LocalRepository) {
    super('AppSetting' , http,repo);
}

  public setBranchInfoId(brachId: number): Observable<ServiceResult> {
    return this.http.post<ServiceResult>(this.ApiUrl + '/SetBranchInfoId?branchId=' + brachId, brachId)
  }

  get(): Observable<TServiceResult<AppSetting>> {
    return this.http.get<TServiceResult<AppSetting>>(this.ApiUrl + '/Get')
  }

  getBranchById(id): Observable<TServiceResult<Branch>> {
    return this.http.get<TServiceResult<Branch>>(this.ApiUrl + '/GetBranchById?id=' + id)
  }

  getAPkByVersion(): Observable<TServiceResult<Branch>> {
    return this.http.get<TServiceResult<Branch>>(this.ApiUrl + '/GetAPkByVersion')
  }
}
